var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.rootElementType,{tag:"component",staticClass:"loading-container text-center"},[_c('i',{staticClass:"fa fa-spin fa-spinner",class:_vm.cssClass,attrs:{"aria-hidden":"true","aria-label":_vm.label}})])}
var staticRenderFns = []

export { render, staticRenderFns }